(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-lazy"] && !Shopify.designMode) return;
  try {
    // Optional: Enhanced lazy loading with fade-in effect
  document.addEventListener('DOMContentLoaded', function() {
    // Check for native lazy loading support
    if ('loading' in HTMLImageElement.prototype) {
      // Native lazy loading supported - add loaded class on load
      const lazyImages = document.querySelectorAll('.lazy-image');
      lazyImages.forEach(function(img) {
        if (img.complete) {
          img.classList.add('loaded');
          if (img.closest('.lazy-image-wrapper')) {
            img.closest('.lazy-image-wrapper').classList.add('loaded');
          }
        } else {
          img.addEventListener('load', function() {
            this.classList.add('loaded');
            if (this.closest('.lazy-image-wrapper')) {
              this.closest('.lazy-image-wrapper').classList.add('loaded');
            }
          }, { once: true });
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Card swatch hover image switch (runs once via Shopify's dedup)
  document.addEventListener('mouseenter', function(e) {
    var swatch = e.target.closest('[data-card-swatch]');
    if (!swatch) return;

    var imageUrl = swatch.dataset.cardSwatchImage;
    if (!imageUrl) return;

    var card = swatch.closest('.product-card');
    if (!card) return;

    var media = card.querySelector('.product-card__media');

    // Create or reuse preview image
    var preview = media.querySelector('.product-card__swatch-preview');
    if (!preview) {
      preview = document.createElement('img');
      preview.className = 'product-card__swatch-preview';
      preview.loading = 'lazy';
      media.appendChild(preview);
    }

    preview.src = imageUrl;
    preview.alt = swatch.getAttribute('title') || '';
    preview.classList.add('is-visible');

    // Update active state
    card.querySelectorAll('[data-card-swatch]').forEach(function(s) {
      s.classList.remove('product-card__swatch--active');
    });
    swatch.classList.add('product-card__swatch--active');
  }, true);

  document.addEventListener('mouseleave', function(e) {
    var swatch = e.target.closest('[data-card-swatch]');
    if (!swatch) return;

    var card = swatch.closest('.product-card');
    if (!card) return;

    var preview = card.querySelector('.product-card__swatch-preview');
    if (preview) preview.classList.remove('is-visible');

    // Restore first swatch as active
    var first = card.querySelector('[data-card-swatch]');
    card.querySelectorAll('[data-card-swatch]').forEach(function(s) {
      s.classList.remove('product-card__swatch--active');
    });
    if (first) first.classList.add('product-card__swatch--active');
  }, true);
  } catch(e) { console.error(e); }
})();

})();
